export default __webpack_public_path__ + "static/media/icon_campaign.59d73f53.svg";